import React, {ComponentProps, ReactElement} from 'react'
import {css} from '@emotion/react'
import styled from '@emotion/styled'

import {
  BottomSheet as AtlasBottomSheet,
  BottomSheetHeader
} from '@daedalus/atlas/src/components/designSystem/BottomSheet'
import {
  HeaderWrapper,
  SubHeader
} from '@daedalus/atlas/src/components/designSystem/BottomSheet/styles'

type AtlasBottomSheetProps = ComponentProps<typeof AtlasBottomSheet>

interface Props extends Omit<AtlasBottomSheetProps, 'titleBarProps'> {
  iconComponent?: ReactElement | null
}

const HeaderIcon = styled.div(
  ({theme}) => css`
    position: absolute;
    width: 64px;
    height: 64px;
    left: 50%;
    top: ${theme.layout.spacing.s600}px;
    transform: translateX(-50%);
  `
)

const StyledBottomSheet = styled(AtlasBottomSheet)(
  ({theme}) => css`
    z-index: 101 !important;
    .react-modal-sheet-container {
      overflow: hidden;
    }
    ${BottomSheetHeader} {
      position: relative;
      height: 72px;
      margin-top: -1px;
      background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzkwIiBoZWlnaHQ9IjcyIiB2aWV3Qm94PSIwIDAgMzkwIDcyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiPgo8bWFzayBpZD0ibWFzazBfMjIyNl8yNTI0OCIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMTQiIHk9IjAiIHdpZHRoPSIzNzYiIGhlaWdodD0iNzIiPgo8cGF0aCBkPSJNMzkwIDEuNDIwNTFlLTA1QzM5MCAxLjQyMDUxZS0wNSA4OC40MDQ0IC0zLjE0NzA3ZS0wNSAxNC45ODgzIDQuMDk4NjRlLTA1Qzk1Ljk4ODMgNC4wOTg2NGUtMDUgOTcuOTg4MyA0NC44MTAxIDE3MC40ODggNjYuNzc2MUMyNDIuOTg3IDg4Ljc0MjIgMzU0LjQ4OCAzNC4zMjg2IDM5MCAzNC4zMjg2VjEuNDIwNTFlLTA1WiIgZmlsbD0iI0Q5RDlEOSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMjIyNl8yNTI0OCkiPgo8cmVjdCB4PSItMC4wMTE3MTg4IiB3aWR0aD0iMzkwIiBoZWlnaHQ9IjgzLjcwNTMiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8yMjI2XzI1MjQ4KSIvPgo8cGF0aCBvcGFjaXR5PSIwLjUiIGQ9Ik0yNTMuMzU2IDQ3Ljk2NTlDMjY4LjQ0NiA0Ny45NjU5IDI3Ny44NzggNjUuNTAxNSAyNzAuMzMzIDc5LjUyOTZMMjA3Ljk2OCAxOTUuNDgyQzIwMC40MjQgMjA5LjUxMiAxODEuNTU5IDIwOS41MTQgMTc0LjAxMyAxOTUuNDg1TDExMS42NDQgNzkuNTI5NkMxMDQuMDk5IDY1LjUwMTUgMTEzLjUzIDQ3Ljk2NTkgMTI4LjYyIDQ3Ljk2NTlIMjUzLjM1NloiIGZpbGw9IiMzRTAwOEEiLz4KPHBhdGggb3BhY2l0eT0iMC43IiBkPSJNMzk4LjkyIC04Ny42Nzk0QzQxMC41MDMgLTg3LjY3OTQgNDE3Ljc0MSAtNzQuMTIwOCA0MTEuOTUgLTYzLjI3NDFMMzc3LjA3MyAyLjA0NjgzQzM3My4wOTkgOS40ODgxMSAzNjUuNzU3IDE0LjA3MjEgMzU3LjgxMSAxNC4wNzIxSDMwNC4wOTFDMjk0LjAyIDE0LjA3MjEgMjg3LjcyNSAyLjI4MTkxIDI5Mi43NjEgLTcuMTQ5OTdMMzI5LjMzOCAtNzUuNjU0MkMzMzMuMzExIC04My4wOTU1IDM0MC42NTMgLTg3LjY3OTQgMzQ4LjYgLTg3LjY3OTRIMzk4LjkyWiIgZmlsbD0iIzNFMDA4QSIvPgo8L2c+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMjIyNl8yNTI0OCIgeDE9Ii0wLjAxMTcwOTYiIHkxPSItMzQuMTI2IiB4Mj0iNzcuMjE5NSIgeTI9IjE5MS4wMDIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzNFMDA4QSIvPgo8c3RvcCBvZmZzZXQ9IjAuNjg5MDY4IiBzdG9wLWNvbG9yPSIjMTcwMDMzIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      flex-shrink: 0;
      margin-bottom: ${theme.layout.spacing.s600}px;
      html[dir='rtl'] & {
        background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzkwIiBoZWlnaHQ9IjcyIiB2aWV3Qm94PSIwIDAgMzkwIDcyIiBmaWxsPSJub25lIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8bWFzayBpZD0ibWFzazBfMjg2N18yMDg1OTgiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIzNzYiIGhlaWdodD0iNzIiPgo8cGF0aCBkPSJNLTAuMDAwMzM1NjkzIDEuNDIwNTFlLTA1Qy0wLjAwMDMzNTY5MyAxLjQyMDUxZS0wNSAzMDEuNTk2IC0zLjE0NzA3ZS0wNSAzNzUuMDEyIDQuMDk4NjRlLTA1QzI5NC4wMTIgNC4wOTg2NGUtMDUgMjkyLjAxMiA0NC44MTAxIDIxOS41MTIgNjYuNzc2MUMxNDcuMDEzIDg4Ljc0MjIgMzUuNTEyMSAzNC4zMjg2IC0wLjAwMDMzNTY5MyAzNC4zMjg2VjEuNDIwNTFlLTA1WiIgZmlsbD0iI0Q5RDlEOSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMjg2N18yMDg1OTgpIj4KPHJlY3Qgd2lkdGg9IjM5MCIgaGVpZ2h0PSI4My43MDUzIiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSAzOTAuMDEyIDApIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMjg2N18yMDg1OTgpIi8+CjxwYXRoIG9wYWNpdHk9IjAuNSIgZD0iTTEzNi42NDQgNDcuOTY1OUMxMjEuNTU0IDQ3Ljk2NTkgMTEyLjEyMiA2NS41MDE1IDExOS42NjcgNzkuNTI5NkwxODIuMDMyIDE5NS40ODJDMTg5LjU3NiAyMDkuNTEyIDIwOC40NDEgMjA5LjUxNCAyMTUuOTg3IDE5NS40ODVMMjc4LjM1NiA3OS41Mjk2QzI4NS45MDEgNjUuNTAxNSAyNzYuNDcgNDcuOTY1OSAyNjEuMzggNDcuOTY1OUgxMzYuNjQ0WiIgZmlsbD0iIzNFMDA4QSIvPgo8cGF0aCBvcGFjaXR5PSIwLjciIGQ9Ik0tOC45MjAzMyAtODcuNjc5NEMtMjAuNTAyNiAtODcuNjc5NCAtMjcuNzQwOSAtNzQuMTIwOCAtMjEuOTUwMyAtNjMuMjc0MUwxMi45MjczIDIuMDQ2ODRDMTYuOTAwOCA5LjQ4ODExIDI0LjI0MzMgMTQuMDcyMSAzMi4xODkzIDE0LjA3MjFIODUuOTA5MkM5NS45ODAzIDE0LjA3MjEgMTAyLjI3NSAyLjI4MTkxIDk3LjIzOTUgLTcuMTQ5OTdMNjAuNjYyMyAtNzUuNjU0MkM1Ni42ODg4IC04My4wOTU1IDQ5LjM0NzIgLTg3LjY3OTQgNDEuNDAwMiAtODcuNjc5NEgtOC45MjAzM1oiIGZpbGw9IiMzRTAwOEEiLz4KPC9nPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzI4NjdfMjA4NTk4IiB4MT0iOS4xMzk5MWUtMDYiIHkxPSItMzQuMTI2IiB4Mj0iNzcuMjMxMiIgeTI9IjE5MS4wMDIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzNFMDA4QSIvPgo8c3RvcCBvZmZzZXQ9IjAuNjg5MDY4IiBzdG9wLWNvbG9yPSIjMTcwMDMzIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==');
      }
    }
    ${HeaderWrapper} {
      height: 100%;
      padding: 0;
    }
    ${SubHeader} {
      padding: 0;
    }
  `
)

export const BrandBottomSheet = ({
  iconComponent,
  children,
  ...props
}: Props) => {
  return (
    <StyledBottomSheet
      {...props}
      headerVariant="floating"
      titleBarProps={{
        centerContent: <HeaderIcon>{iconComponent}</HeaderIcon>
      }}
    >
      {children}
    </StyledBottomSheet>
  )
}
